<template>
  <section style="width: 100%">
    <div>
    <!-- /////////////// WRAPPER -->
      <!-- //TITLE MOBILE -->
      <h1 class="mobile">Commerciaux</h1>
      <!-- //TITLE MOBILE -->

      <!-- //CONTENT -->
      <div class="block__commercials content__commercials">

        <!-- SIDEBAR -->
        <SidebarSearch class="mobile"/>
        <!-- SIDEBAR -->

        <div class="right">
        <!-- //TITLE DESKTOP -->
          <div class="desktop">
            <h1>Commerciaux</h1>
          <!-- //TITLE DESKTOP -->

          <!-- //BT FAVORITE -->
            <b-button class="bt btn-favoris mt-4 ">
              <div class="left" slot="start">
                <span>
                  <font-awesome-icon :icon="['fas', 'star']" />
                </span>
                <p class="title">Favoris</p>
              </div>
              <div class="right" slot="end">
                <p class='label'>Aucun</p>
                <span>
                  <font-awesome-icon :icon="['fas', 'chevron-right']" />
                </span>
              </div>
            </b-button>
          </div>
        <!-- //BT FAVORITE -->

          <!-- //ILLUSTRATION -->
          <div class="illustration" v-if="favorites.length === 0">
            <img :src="'/img/browse_illustration.svg'" alt="illustration">
            <div class="title">Aucun suivi</div>
            <div class="desc">Retrouvez ici le suivi de vos commerciaux</div>
          </div>
          <!-- //ILLUSTRATION -->

          <div class="desktop" v-else>
            <h1 class="desktop">Favoris</h1>
            <b-row>
              <b-col sm='12' md='6' v-for="(sublist, type) in favorites" :key="type">
                <div class="text-primary pb-3">{{type}}</div>
                <b-list-group class="block__commercialResume">
                  <b-list-group-item v-for="(list,index) in sublist" :key="index" :class="{negatif : list.negatif}" style="cursor: pointer" v-on:click="$router.push('/commerciaux/commercial/' + list.id)">
                    <div class="fullname">
                      <PuSkeleton :loading="isLoading" :count="1" height="20px">
                        {{list.fullName}}
                      </PuSkeleton>
                    </div>
                    <div class="right d-none" :class="list.progression === '+' ? 'positif' : 'negatif'">
                      <PuSkeleton :loading="isLoading" :count="1" height="20px" width="20px">
                      <span>
                        <font-awesome-icon v-if="list.progression === '+'" :icon="['far', 'chart-line']" />
                        <font-awesome-icon v-if="list.progression === '-'" :icon="['far', 'chart-line-down']" />
                      </span>
                        <div class="number">{{Math.round(list.number)}}%</div>
                      </PuSkeleton>
                    </div>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
            </b-row>
          </div>

        </div>
      <!-- //CONTENT -->
    </div>
    <!-- /////////////// WRAPPER -->
    </div>




    <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->
      <transition name="slide">
        <keep-alive>
          <router-view class="transition"></router-view>
        </keep-alive>
      </transition>
    <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->

    <!-- /////////////// ROUTER VIEW -> MODAL = CHILDS -->
    <transition name="modal">
      <keep-alive>
        <router-view name="helper" class="myModal"></router-view>
      </keep-alive>
    </transition>
    <!-- /////////////// ROUTER VIEW -> MODAL = CHILDS -->


  </section>
</template>


<script>
import { mapGetters } from 'vuex'
import SidebarSearch from '../../../module/sidebar/SidebarSearch'
import ParentMixin from '../../ParentMixin'
import CatMixin from '../../category/CatMixin'
import ApiService from '../../../../services/ApiService'

export default {
  name:"commercialsHome",
    components:{
      SidebarSearch,
    },
    mixins: [
      ParentMixin,
      CatMixin
    ],
    computed: {
      ...mapGetters([
      ])
    },
    data () {
      return {
        isLoading:true,
        favorites: []
      }
    },
    mounted(){
      this.$store.dispatch('showHeader',true);
    },
    created (){
      this.isLoading = true;
      this.getData().then(() => this.isLoading = false);
    },
    methods : {
      async getData(){
        await ApiService.getParcourirApi().getFavoritesCommercials().then((data) => {
          this.favorites = data.data;
        });
      }
    },
   watch: {
  }
};
</script>
